<div class="kuber-ai-wrapper">
  <iframe
    *ngIf="iframeSrc"
    [src]="iframeSrc"
    (load)="onIframeLoaded()"
    width="100%"
    height="100%"
    allow="clipboard-write"
    frameborder="0">
  </iframe>
</div>